import {NgClass, NgIf} from '@angular/common';
import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  imports: [
    NgClass,
    NgIf
  ],
  styleUrls: ['./dialog-wrapper.component.scss']
})
export class DialogWrapperComponent {
  constructor() {}

  @Output() closeEvent = new EventEmitter<boolean>()
  @ViewChild('dialogElement', { static: false }) dialogElement: ElementRef;

  dialogIsOpen = false;

  openDialog(): void {
    this.dialogIsOpen = true;
    this.dialogElement.nativeElement.showModal();
  }
  closeDialog(): void {
    this.dialogIsOpen = false;
    this.dialogElement.nativeElement.close();
    this.closeEvent.emit(true)
  }

  toggleDialog(): void {
    this.dialogIsOpen = !this.dialogIsOpen;
    if (this.dialogIsOpen) {
      this.openDialog();
    }
    if (!this.dialogIsOpen) {
      this.closeDialog();
      this.closeEvent.emit(true)
    }
  }

  dialogListener() {
    this.dialogIsOpen = false;
    this.dialogElement.nativeElement.close();
    this.closeEvent.emit(true)
  }
}
